import { useState } from "react";
import type { CatalogItem } from "../api";

export function ExperienceCover({ item, compact = false, priority = false }: { item: CatalogItem; compact?: boolean; priority?: boolean }) {
  const [imageFailed, setImageFailed] = useState(false);
  const image = imageFailed ? undefined : item.cover.image;

  return (
    <div
      className={`experience-cover cover-${item.cover.accent} motif-${item.cover.motif}${image ? " has-art" : ""}${compact ? " is-compact" : ""}`}
      role={image ? undefined : "img"}
      aria-label={image ? undefined : item.cover.alt}
    >
      {image && (
        <img
          className="cover-art"
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          decoding="async"
          onError={() => setImageFailed(true)}
        />
      )}
      <span className="cover-art-shade" aria-hidden="true" />
      <span className="cover-floor floor-one">
        <i /><i /><i />
      </span>
      <span className="cover-floor floor-two">
        <i /><i /><i />
      </span>
      <span className="cover-floor floor-three">
        <i /><i /><i />
      </span>
      <span className="cover-signal" aria-hidden="true" />
      {item.cover.motif === "window-304" && <strong className="room-number">304</strong>}
      {item.cover.motif === "paired-windows" && <span className="paired-line" aria-hidden="true" />}
      {item.cover.motif === "party-building" && <span className="party-orbit" aria-hidden="true" />}
    </div>
  );
}
